import { createNewModel } from "../actions/modelAction";
import { createNewUser } from "../actions/userActions";
import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  users: {
    regionsList: [],
    salesOfficeList: [],
    rolesList: [],
    userRegionList: [],
    userSalesOfficeList: [],
    regionBasedSalesOffice:[],
    regionUserList: [],
    isLoading: false,
    hasError: false,
  },
  createNewUser: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  updateUser:{
    data: undefined,
    isLoading: false,
    hasError: false
  },
  deleteUser:{
    data:undefined,
    isLoading:false,
    hasError:false
  },
  regionCheckbox:[],
  salesOfficeCheckbox:[],
  renderUsersListData:[]
};

export const userReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_U_REGIONS:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_U_REGIONS_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, regionsList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_U_REGIONS_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, regionsList: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.GET_U_SALESOFFICE:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_U_SALESOFFICE_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, salesOfficeList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_U_SALESOFFICE_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, salesOfficeList: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.GET_U_ROLES:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_U_ROLES_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, rolesList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_U_ROLES_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, rolesList: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.GET_USER_MAPPED_REGIONS:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_REGIONS_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, userRegionList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_REGIONS_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, userRegionList: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.GET_BY_USER_MAPPED_REGIONS:
        return {
          ...newState,
          users: { ...newState.users, isLoading: true, hasError: false },
        };
      case actionTypes.GET_BY_USER_MAPPED_REGIONS_SUCCESS:
        return {
          ...newState,
          users: { ...newState.users, regionUserList: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.GET_BY_USER_MAPPED_REGIONS_FAILURE:
        return {
          ...newState,
          users: { ...newState.users, regionUserList: action.payload, isLoading: false, hasError: true },
        };

    case actionTypes.GET_USER_MAPPED_SALESOFFICE:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_SALESOFFICE_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, userSalesOfficeList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_SALESOFFICE_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, userSalesOfficeList: action.payload, isLoading: false, hasError: true },
      };
    
    case actionTypes.CREATE_NEW_TOOL:
      return {
        ...newState,
        createNewUser: { ...newState.createNewUser, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_TOOL_SUCCESS:
      return {
        ...newState,
        createNewUser: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_TOOL_FAILURE:
      return {
        ...newState,
        createNewUser: { data: action.payload, isLoading: false, hasError: true },
      };
    case actionTypes.REGION_SELECTION:
      return{
        ...newState,
        regionCheckbox: action.payload
      } 
    case actionTypes.SALES_OFFICE_SELECTION:
      return{
        ...newState,
        salesOfficeCheckbox: action.payload
      }   
    case actionTypes.USER_TABLE_DATA_CREATION:
      return{
        ...newState,
        renderUsersListData:action.payload
      }
    case actionTypes.REGION_BASED_OFFICE_START:
      return{
        ...newState,
        regionBasedSalesOffice:{...newState.users,isLoading:true,hasError:false}
      }    
    case actionTypes.REGION_BASED_OFFICE_SUCCESS:
      return{
        ...newState,
        users:{...newState.users,regionBasedSalesOffice:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.REGION_BASED_OFFICE_FAILURE:
      return{
        ...newState,
        users:{...newState.users,regionBasedSalesOffice:action.payload,isLoading:false,hasError:true}
      }
    case actionTypes.CREATE_NEW_USER_START:
      return{
        ...newState,
        createNewUser:{...newState.createNewUser,isLoading:true,hasError:false}
      }    
    case actionTypes.CREATE_NEW_USER_SUCCESS:
      return{
        ...newState,
        createNewUser:{...newState.createNewUser,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.CREATE_NEW_USER_FAILURE:
      return{
        ...newState,
        createNewUser:{...newState.createNewUser,data:action.payload,isLoading:false,hasError:false}
      }
    case actionTypes.UPDATE_USER_START:
      return{
        ...newState,
        updateUser:{...newState.updateUser,isLoading:true,hasError:false}
      }
    case actionTypes.UPDATE_USER_SUCCESS:
      return{
        ...newState,
        updateUser:{...newState.updateUser,data:action.payload,isLoading:false,hasError:false}
      }      
    case actionTypes.UPDATE_USER_FAILURE:
      return{
        ...newState,
        updateUser:{...newState.updateUser,data:action.payload,isLoading:false,hasError:true}
      } 
    case actionTypes.DELETE_USER_START:
      return{
        ...newState,
        deleteUser:{...newState.deleteUser,isLoading:true,hasError:false}
      }  
    case actionTypes.DELETE_USER_SUCCESS:
      return{
        ...newState,
        deleteUser:{...newState.deleteUser,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.DELETE_USER_FAILURE:
      return{
        ...newState,
        deleteUser:{...newState.deleteUser,data:action.payload,isLoading:false,hasError:true}
      }
    default:
      return { ...newState };
  }
};
